"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ripple_keypairs_1 = require("ripple-keypairs");
var Utils = __importStar(require("../utils"));
var Account_1 = __importDefault(require("../schema/Account"));
var familySeed = function (familyseed, options) {
    var Keypair = (0, ripple_keypairs_1.deriveKeypair)(familyseed, options);
    var Address = (0, ripple_keypairs_1.deriveAddress)(Keypair.publicKey);
    return new Account_1.default({
        algorithm: Utils.getAlgorithmFromKey(Keypair.privateKey),
        address: Address,
        familySeed: familyseed,
        keypair: Keypair
    });
};
exports.default = familySeed;
